module.exports = __webpack_public_path__ + "static/media/revista junio2008.1a87bab6.png";